// Raftel · Bloque 1: diccionario único de textos de ayuda ("qué es" / "para qué sirve").
// Se usa con <HelpTooltip topic="..." /> junto a botones y campos clave.
// Máx. ~30 entradas: solo lo más importante de Contactos, Empresas/Directorio,
// Tratos, Mensajes y Copiloto de llamadas. Textos en español, cortos.

export interface HelpText {
  que: string;
  para: string;
}

export const HELP_TEXTS = {
  // Contactos
  "contact.create": {
    que: "Nuevo contacto",
    para: "Agrega una persona a una empresa que ya está en el CRM.",
  },
  "contact.import": {
    que: "Importar contactos",
    para: "Sube un CSV para cargar varios contactos de una vez.",
  },
  "contact.export_vcard": {
    que: "Exportar a vCard",
    para: "Descarga este contacto para guardarlo en tu teléfono.",
  },
  "contact.tags": {
    que: "Etiquetas",
    para: "Clasifica al contacto para poder filtrarlo después.",
  },
  "contact.merge": {
    que: "Fusionar contacto",
    para: "Une dos fichas duplicadas de la misma persona en una sola.",
  },
  "contact.notes": {
    que: "Notas",
    para: "Registra qué pasó en cada llamada, correo o mensaje.",
  },
  // Empresas / Directorio
  "directory.promote": {
    que: "Pasar al CRM",
    para: "Convierte empresas del directorio en oportunidades reales para trabajarlas.",
  },
  "directory.filters": {
    que: "Filtros del directorio",
    para: "Acota las 2.5 millones de empresas por giro, tamaño o ubicación.",
  },
  "directory.fits": {
    que: "Encaje (fit)",
    para: "Qué tan bien le queda cada producto a esta empresa, según sus datos.",
  },
  "company.thermo": {
    que: "Termómetro",
    para: "Qué tan caliente está la relación con esta empresa ahora mismo.",
  },
  "company.tier": {
    que: "Categoría (tier)",
    para: "Qué tan prioritaria es esta empresa para enfocar tu tiempo.",
  },
  "company.offers": {
    que: "Productos",
    para: "Qué productos de tu portafolio le puedes ofrecer a esta empresa.",
  },
  // Tratos
  "deal.stage": {
    que: "Etapa",
    para: "En qué paso del proceso de venta está este trato.",
  },
  "deal.create": {
    que: "Nueva oportunidad",
    para: "Abre un trato nuevo para una empresa con un producto específico.",
  },
  "deal.lost": {
    que: "Marcar como perdido",
    para: "Cierra el trato sin venta y guarda el motivo para aprender de él.",
  },
  "deal.delete": {
    que: "Eliminar trato",
    para: "Borra esta oportunidad por completo. No se puede deshacer.",
  },
  "deal.offer": {
    que: "Producto del trato",
    para: "A cuál de tus productos pertenece esta oportunidad.",
  },
  "pipeline.board": {
    que: "Tablero de oportunidades",
    para: "Arrastra las tarjetas entre columnas para mover el trato de etapa.",
  },
  // Mensajes
  "templates.send": {
    que: "Enviar",
    para: "Manda el mensaje con la plantilla ya rellenada con los datos del contacto.",
  },
  "templates.review": {
    que: "Revisar mensajes",
    para: "Revisa el texto antes de que salga, para que no se vea robótico.",
  },
  "templates.variables": {
    que: "Variables",
    para: "Textos como {{nombre}} que se rellenan solos con los datos de cada contacto.",
  },
  "templates.channel": {
    que: "Canal",
    para: "Por dónde se manda este mensaje: WhatsApp, correo u otro.",
  },
  "sequences.enroll": {
    que: "Inscribir en cadencia",
    para: "Programa una serie de mensajes y tareas de seguimiento automáticas.",
  },
  // Copiloto de llamadas
  "calls.start": {
    que: "Iniciar sesión de llamadas",
    para: "Arma una fila con tus oportunidades más calientes para llamarlas seguidas.",
  },
  "calls.capture": {
    que: "Grabar llamada",
    para: "Captura el audio para que la IA te sugiera qué decir y resuma después.",
  },
  "calls.consent": {
    que: "Aviso de grabación",
    para: "Confirma que informaste a la otra persona antes de grabar.",
  },
  "calls.suggestion": {
    que: "Sugerencias en vivo",
    para: "Ideas de qué decir a continuación, según cómo va la llamada.",
  },
  "calls.summary": {
    que: "Resumen de la llamada",
    para: "Lo que se dijo, listo para copiar a la nota del contacto.",
  },
  "calls.outcome": {
    que: "Resultado de la llamada",
    para: "Qué pasó, para que la próxima acción se programe sola.",
  },
} as const satisfies Record<string, HelpText>;

export type HelpTopic = keyof typeof HELP_TEXTS;
